"use client";

import { Slider } from "@base-ui/react/slider";

import { cn } from "@/lib/utils";

type StyledSliderProps = Omit<Slider.Root.Props<number>, "children">;

export function StyledSlider({
  "aria-label": ariaLabel,
  "aria-valuetext": ariaValueText,
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  ...props
}: StyledSliderProps) {
  return (
    <Slider.Root
      className={cn(
        "relative flex w-full touch-none select-none items-center data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col data-disabled:opacity-50",
        className
      )}
      data-slot="slider"
      defaultValue={defaultValue}
      max={max}
      min={min}
      value={value}
      {...props}
    >
      <Slider.Control className="flex w-full items-center data-[orientation=vertical]:h-full data-[orientation=vertical]:flex-col">
        <Slider.Track
          className="relative grow overflow-hidden rounded-full bg-gray-300 outline outline-gray-400 -outline-offset-1 data-[orientation=horizontal]:h-1.5 data-[orientation=vertical]:h-full data-[orientation=horizontal]:w-full data-[orientation=vertical]:w-1.5"
          data-slot="slider-track"
        >
          <Slider.Indicator
            className="absolute bg-gray-1200 data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
            data-slot="slider-range"
          />
        </Slider.Track>
        <Slider.Thumb
          aria-label={ariaLabel}
          aria-valuetext={ariaValueText}
          className="relative block size-4 shrink-0 rotate-45 rounded bg-preview-bg shadow-border before:absolute before:-inset-3 before:content-[''] has-focus-visible:outline-2 has-focus-visible:outline-offset-2 has-focus-visible:outline-gray-1100 data-disabled:pointer-events-none"
          data-slot="slider-thumb"
        />
      </Slider.Control>
    </Slider.Root>
  );
}
